import { Button, Col, DatePicker, Form, Input, Modal, notification, Row, Select, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import React, { useState, useEffect } from "react";
import { expenseVoucherService } from "../../../../../services";
import dayjs from "dayjs";
import MaterialLikeSelect from "../../../../../components/MaterialLikeSelect";
import MaterialLikeInput from "../../../../../components/MaterialLikeInput";

function EditExpense({ isVisible, setEditModal, vendors, setRefresh, subAccount, expenseAcc, record }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [filteredSubAccount, setFilteredSubAccount] = useState([]);
  const [filteredVendors, setFilteredVendors] = useState([]);

  const handleCancel = () => {
    setRefresh(true);
    form.resetFields();
    setEditModal(false);
  };

  const handleExpChange = (value) => {
    if (!value) {
      setFilteredSubAccount([]);
      setFilteredVendors([]);
      return;
    }

    const { vendor_category_id, id } = JSON.parse(value);
    const filteredSubAcc = subAccount.filter(
      (subAccount) => subAccount.expense_category_id === id
    );
    setFilteredSubAccount(filteredSubAcc);
    const filteredVendors = vendors.filter(
      (vendor) => vendor.vendors_categorys_id === vendor_category_id
    );
    setFilteredVendors(filteredVendors);
  };

  const onFinish = async (values) => {
    setLoading(true);
    const expense = JSON.parse(values.expense_category);
    const vendor_cat_id = vendors.find(
      (vendor) => values.vendor == vendor.id
    )?.vendors_categorys_id;
    const data = {
      ...values,
      cash_flow_id: record?.id,
      vendor_category: vendor_cat_id,
      expense_category: expense.id,
      due_date: values.due_date.format("YYYY-MM-DD"),
      voucher_date: values.voucher_date.format("YYYY-MM-DD"),
      is_future: 0,
      attachment: values.attachment ? values.attachment : null,
      description: values.description ? values.description : "",
    };
    const response = await expenseVoucherService.editExpense(data);
    if (response.success) {
      notification.success({
        message: "Updated Successfully!",
        description: response.message,
        placement: "topRight",
      });
    } else {
      notification.error({
        message: "Error adding",
        description: response.message,
        placement: "topRight",
      });
    }
    setLoading(false);
    handleCancel();
  };

  useEffect(() => {
    form.setFieldsValue({
      ...record,
      expense_category: JSON.stringify(record?.expense_category),
      voucher_date: dayjs(record?.voucher_date).tz(),
      due_date: dayjs(record?.due_date).tz(),
    });
    handleExpChange(JSON.stringify(record?.expense_category));
  }, [isVisible]);

  return (
    <Modal
      title={<div style={{ width: "100%" }}>Make Expense</div>}
      open={isVisible}
      onCancel={handleCancel}
      footer={null}
      closable={true}
      width={700}
      style={{ padding: "15px" }}
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        requiredMark={false}
        initialValues={{
          due_date: dayjs().tz(),
          voucher_date: dayjs().tz(),
        }}
      >
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item
              name="expense_category"
              rules={[
                {
                  required: true,
                  message: "Please select an appointment type",
                },
              ]}
            >
              <MaterialLikeSelect
                label="Expense Account"
                required
                value={form.getFieldValue("expense_category")}
                onChange={(value) => {
                  handleExpChange(value); // same as your previous onChange logic
                  form.setFieldValue("expense_category", value);
                }}
                options={expenseAcc?.map((expense) => ({
                  id: expense.id,
                  value: JSON.stringify(expense), // stringify object for Select compatibility
                  label: expense.name,
                }))}
              />
              {/* <Select
                placeholder="Select Inter-Company"
                onChange={(value) => handleExpChange(value)}
              >
                {expenseAcc.map((expense) => (
                  <Select.Option
                    key={expense.id}
                    value={JSON.stringify(expense)}
                  >
                    {expense.name}
                  </Select.Option>
                ))}
              </Select> */}
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="expense_subcategory"
              rules={[
                {
                  required: true,
                  message: "Please select an appointment type",
                },
              ]}
            >
              <MaterialLikeSelect
                label="Sub-Account"
                required
                value={form.getFieldValue("expense_subcategory")}
                onChange={(value) => form.setFieldValue('expense_subcategory', value)}
                options={filteredSubAccount?.map((subacc) => ({
                  id: subacc.id,
                  value: subacc.id,
                  label: subacc.name
                }))}
              />
              {/* <Select placeholder="Select Inter-Company">
                {filteredSubAccount.map((subacc) => (
                  <Select.Option key={subacc.id} value={subacc.id}>
                    {subacc.name}
                  </Select.Option>
                ))}
              </Select> */}
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="voucher_number"
              rules={[{ required: true, message: "Please enter the end time" }]}
            >
              <MaterialLikeInput
                label="Voucher Number"
                required
                value={form.getFieldValue("voucher_number")}
                onChange={(e) => form.setFieldValue("voucher_number", e.target.value)}
                readOnly
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="Voucher Date"
              name="voucher_date"
              rules={[{ required: true, message: "Please enter the end time" }]}
            >
              <DatePicker style={{ width: "100%" }} />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              label="Vendor Name"
              name="vendor"
              rules={[
                {
                  required: true,
                  message: "Please select an appointment type",
                },
              ]}
            >
              <Select placeholder="Select type">
                {filteredVendors?.map((vendor) => (
                  <Select.Option key={vendor.id} value={vendor.id}>
                    {vendor.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="Vendor Invoice No"
              name="vendor_invoice_no"
              rules={[{ required: true, message: "Please enter the end time" }]}
            >
              <Input placeholder="123" />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              label="Amount"
              name="amount"
              rules={[
                {
                  required: true,
                  message: "Please select an appointment type",
                },
              ]}
            >
              <Input placeholder="Enter Amount" />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              label="Container No"
              name="container_number"
              rules={[{ required: true, message: "Please enter the end time" }]}
            >
              <Input placeholder="2024-11-06" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="Booking No"
              name="booking_number"
              rules={[{ required: true, message: "Please enter the end time" }]}
            >
              <Input placeholder="2024-11-06" />
            </Form.Item>
          </Col>
          <Col span={16}>
            <Form.Item
              label="Due Date"
              name="due_date"
              rules={[{ required: true, message: "Please enter the end time" }]}
            >
              <DatePicker style={{ width: "100%" }} disabled />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item label="Attachment" name="attachment">
              <Upload
                id="uploadInput"
                action="/upload"
                beforeUpload={() => false}
                listType="picture"
                style={{
                  width: "100%",
                }}
              >
                <Button
                  type="dashed"
                  icon={<UploadOutlined />}
                  style={{
                    width: "100%",
                    border: "1px solid #ccc",
                    padding: 18,
                  }}
                >
                  Upload File
                </Button>
              </Upload>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Description" name="description">
              <Input.TextArea
                placeholder="Enter special notes here..."
                rows={5}
              />
            </Form.Item>
          </Col>
        </Row>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
          <Col span={6} style={{ textAlign: "right" }}>
            <Form.Item style={{ marginTop: 10, textAlign: "right" }}>
              <Button
                type="primary"
                style={{ width: "100%" }}
                htmlType="submit"
                loading={loading}
              >
                Update
              </Button>
            </Form.Item>
          </Col>
        </div>
      </Form>
    </Modal>
  );
}
export default EditExpense;
